<template>
  <div class="search-content">
<!--    <keep-alive v-if="$route.meta.keepAlive">-->
      <router-view />
<!--    </keep-alive>-->
  </div>
</template>

<script>
  export default {
    name: 'ApplyLayout',
    data () {
      return {
        tabs: {
          items: [
            // {
            //   key: '1',
            //   title: '单位备案'
            // },
            {
              key: '1',
              title: '报名管理'
            },
            // {
            //   key: '3',
            //   title: '项目报名管理'
            // },
            // {
            //   key: '4',
            //   title: '信息确认管理'
            // },
            // {
            //   key: '5',
            //   title: '食宿信息管理'
            // },
            // {
            //   key: '7',
            //   title: '报名管理(集赞)'
            // },
            // {
            //   key: '8',
            //   title: '项目报名管理(集赞)'
            // },
            // {
            //   key: '6',
            //   title: '单位管理'
            // },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/sai/DanweiList':
                return '-1'
              case '/sai/ApplyList':
                return '1'
              case '/sai/ApplySubjectList':
                return '3'
              case '/sai/ConfrimApplyList':
                return '4'
              case '/sai/ShisuApplyList':
                return '5'
              case '/sai/DanweiManageList':
                return '6'
              case '/sai/ApplyListZan':
                return '7'
              case '/sai/ApplySubjectListZan':
                return '8'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '-1':
                this.$router.push('/sai/DanweiList')
                break
              case '1':
                this.$router.push('/sai/ApplyList')
                break
              case '3':
                this.$router.push('/sai/ApplySubjectList')
                break
              case '4':
                this.$router.push('/sai/ConfrimApplyList')
                break
              case '5':
                this.$router.push('/sai/ShisuApplyList')
                break
              case '6':
                this.$router.push('/sai/DanweiManageList')
                break
              case '7':
                this.$router.push('/sai/ApplyListZan')
                break
              case '8':
                this.$router.push('/sai/ApplySubjectListZan')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
